import OnboardingUserData from "./OnboardingUserData";

export default OnboardingUserData;
